/**
 * Argon2id key derivation — the TS half of the platform's single source of
 * truth. Parameters are pinned to `wiser-e2e` Rust `kdf.rs` /
 * `vectors/wire-vectors.json`. Drift would silently break unlock_blob decryption.
 *
 * Extracted verbatim from wisermail-web/src/services/crypto.ts.
 */

import { argon2id } from './provider';

/** Argon2id memory cost (KiB). 64 MiB. */
export const ARGON2_M_COST_KIB = 65_536;
/** Argon2id time cost (iterations). */
export const ARGON2_T_COST = 3;
/** Argon2id parallelism. */
export const ARGON2_P_COST = 1;
/** Argon2id output length (bytes). */
export const ARGON2_OUTPUT_LEN = 32;

/**
 * Derive the per-user wrapping key `WK_user` (a.k.a. KEK) from a passphrase and
 * salt. Argon2id, m=64MiB, t=3, p=1, 32-byte output — matches the Rust
 * `derive_wk_user` exactly. `salt` is the opaque bytes from `users.wk_salt`.
 */
export async function deriveWkUser(
  passphrase: string,
  salt: Uint8Array,
): Promise<Uint8Array> {
  return argon2id(passphrase, salt, {
    memoryKib: ARGON2_M_COST_KIB,
    iterations: ARGON2_T_COST,
    parallelism: ARGON2_P_COST,
    outputLen: ARGON2_OUTPUT_LEN,
  });
}
